import React from 'react';
import { FooterContainer, TextFooter } from '../../pages/welcome/styles';
import Logo from '../../../src/assets/zenbox-logo.svg'
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const isAdminPage = location.pathname.includes('admin');

    return(
        <FooterContainer className='app-footer' style={{ color: (isAdminPage ? '#808086' : '#FFF') }}>
            <TextFooter style={{color: (isAdminPage ? '#808086' : '#FFF')}}>{t('brand.poweredBy')}</TextFooter>
            <img src={Logo} draggable ="false" alt="Logo" style={{ width: '15%', maxWidth: '50px', minWidth: '60px', filter: (isAdminPage ? 'brightness(0.5) saturate(0)' :  'none')}} />
        </FooterContainer>
    )

}

export default Footer;
